package com.essntl.features.invoice.data.supabase

import com.essntl.features.invoice.domain.model.InvoiceModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InvoiceDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
    @SerialName("payment_link_ids")
    val paymentLinkIds: List<String>?,
    @SerialName("proposal_services")
    val proposalServiceIds: List<String>?,
    @SerialName("itinerary_services")
    val itineraryServiceIds: List<String>?,
    @SerialName("extra_service_ids")
    val extraServiceIds: List<String>?,
    @SerialName("qb_id")
    val qbId: String?,
    @SerialName("proposal_id")
    val proposalId: String?,
    @SerialName("itinerary_id")
    val itineraryId: String?,
    @SerialName("due_date")
    val dueDate: String?,
) {
    fun toModel() = InvoiceModel(
        id = id,
        createdAt = createdAt,
        updatedAt = updatedAt,
        updatedBy = updatedBy,
        paymentLinkIds = paymentLinkIds,
        proposalServiceIds = proposalServiceIds,
        itineraryServiceIds = itineraryServiceIds,
        extraServiceIds = extraServiceIds,
        qbId = qbId,
        dueDate = dueDate,
        proposalId = proposalId,
        itineraryId = itineraryId,
    )
}
